import { createFileApi, postFileToSignedUrlApi } from '../api/files';

/**
 * Saves a list of files and returns the list of their saved UUIDs
 *
 * @param files The files to save {$link https://developer.mozilla.org/en-US/docs/Web/API/File}
 * @returns {Promise<*[]>}
 */
export default async function (files = []) {
  if (!files || !files.length) {
    return [];
  }

  const promises = files.map((file) => {
    return new Promise(async (resolve, reject) => {
      try {
        let splitName = file.name.split('.');
        let extension = splitName.pop();
        let name = file.name.replace(`.${extension}`, '');
        // Get signed URL
        let createDetails = await createFileApi(name, extension, file.type);
        // Upload the photo to GCS
        await postFileToSignedUrlApi(createDetails.signedUrl, file);
        resolve(createDetails.uuid);
      } catch (e) {
        reject(e);
      }
    });
  });

  return await Promise.all(promises);
}
